<template>
  <div class="share">
    <ClipboardIcon></ClipboardIcon>
    <ShareIcon
      :href="facebookUrl"
      platform="facebook"
      blank
    >
      <svg viewBox="0 0 34 35" xmlns="http://www.w3.org/2000/svg"><path d="M20.764 14.396l-.196 2.544h-2.61v8.84h-3.295v-8.84h-1.758v-2.544h1.758v-1.709c0-.754.019-1.916.567-2.636.577-.76 1.368-1.28 2.729-1.28 2.219 0 3.153.317 3.153.317l-.44 2.605s-.732-.212-1.416-.212c-.684 0-1.297.245-1.297.93v1.985h2.805zM17.008.268C7.616.268 0 7.883 0 17.276c0 9.393 7.616 17.008 17.008 17.008 9.393 0 17.008-7.615 17.008-17.008C34.016 7.883 26.4.268 17.008.268z" fill="#F66" fill-rule="evenodd"/></svg>
    </ShareIcon>
    <ShareIcon
      :href="twitterUrl"
      platform="twitter"
      blank
    >
      <svg viewBox="0 0 35 35" xmlns="http://www.w3.org/2000/svg"><path d="M24.305 14.63c.007.149.01.3.01.453 0 4.619-3.515 9.944-9.946 9.944a9.909 9.909 0 0 1-5.357-1.57 7.011 7.011 0 0 0 5.175-1.449 3.495 3.495 0 0 1-3.265-2.425 3.468 3.468 0 0 0 1.578-.061 3.496 3.496 0 0 1-2.804-3.427v-.043a3.49 3.49 0 0 0 1.584.436 3.497 3.497 0 0 1-1.082-4.668 9.92 9.92 0 0 0 7.205 3.653 3.494 3.494 0 0 1 5.955-3.188 6.974 6.974 0 0 0 2.22-.847 3.489 3.489 0 0 1-1.537 1.933 7.009 7.009 0 0 0 2.008-.55 7.042 7.042 0 0 1-1.744 1.809M17.515.269C8.124.269.509 7.884.509 17.276c0 9.394 7.615 17.008 17.008 17.008 9.393 0 17.008-7.614 17.008-17.008C34.525 7.884 26.91.269 17.517.269" fill="#F66" fill-rule="evenodd"/></svg>
    </ShareIcon>
    <ShareIcon
      :href="mailUrl"
      platform="mail"
    >
      <svg viewBox="0 0 35 34" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 34.284h171.121V0H0z"/></defs><g transform="translate(-137)" fill="none" fill-rule="evenodd"><path fill="#F66" d="M159.305 12.168h-10.252l5.3 4.264z"/><path fill="#F66" d="M160.84 13.239l-6.45 5.553-7.006-5.637v8.692h13.457z"/><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M145.569 23.663h17.086v-13.31h-17.086v13.31zM154.113 0c-9.394 0-17.009 7.616-17.009 17.008 0 9.393 7.615 17.008 17.009 17.008 9.393 0 17.008-7.615 17.008-17.008C171.121 7.616 163.506 0 154.113 0z" fill="#F66" mask="url(#b)"/></g></svg>
    </ShareIcon>
  </div>
</template>

<script>
import queryString from 'query-string'
import ShareIcon from './ShareIcon'
import ClipboardIcon from './ClipboardIcon'

export default {
  name: 'Share',
  computed: {
    facebookUrl () {
      const u = 'https://app.nos.nl/depressie/index.html'
      const parameters = {
        u
      }
      return `https://facebook.com/share.php?${queryString.stringify(parameters)}`
    },
    twitterUrl () {
      const text = 'In deze special laat NOS op 3 je ervaren hoe het is om een depressie te hebben. #ikziewatjijnietziet'
      const u = 'https://app.nos.nl/depressie/index.html'
      const parameters = {
        text,
        url: u
      }
      return `https://twitter.com/intent/tweet?${queryString.stringify(parameters)}`
    },
    mailUrl () {
      const subject = 'Depressie onder Jongeren'
      const body = 'In deze special laat NOS op 3 je ervaren hoe het is om een depressie te hebben. #ikziewatjijnietziet'
      const parameters = {
        subject,
        body
      }
      return `mailto:${queryString.stringify(parameters)}`
    }
  },
  components: {
    ShareIcon,
    ClipboardIcon
  }
}
</script>

<style lang="scss" scoped>
  .share {
    font-size: 0;
    margin: 0 auto;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/share/Share.vue